import ApiFetcher from "../utils/ApiFetcher";
import { put, call } from "redux-saga/effects";
import { makeQueryString } from "../utils/urls";
import {
  sagaListSuccess,
  sagaOneSuccess,
  sagaSearchSuccess,
  sagaCreateSuccess,
  sagaUpdateSuccess
} from "../actions/ActionTypes";
import { showSuccessMsg, showErrorMsg } from "../actions";

const ADMINS = "ADMINS";
const ADMIN = "ADMIN";
const apiFetcher = new ApiFetcher();
export function* fetchAdmins(action) {
  let queryString = makeQueryString(action.data);
  try {
    const res = yield call(apiFetcher.findAll, `admins?${queryString}`);
    yield put({
      type: sagaListSuccess(ADMINS),
      data: res.data
    });
  } catch (e) {}
}

export function* searchAdmins(action) {
  let queryString = makeQueryString(action.data);
  try {
    const res = yield call(apiFetcher.findAll, `admins?${queryString}`);
    yield put({
      type: sagaSearchSuccess(ADMINS),
      data: res.data
    });
  } catch (e) {}
}

export function* fetchAdmin(action) {
  try {
    const res = yield call(apiFetcher.find, "admins", action.id);
    yield put({
      type: sagaOneSuccess(ADMIN),
      data: res.data
    });
  } catch (e) {}
}

export function* createAdmin(action) {
  try {
    const data = { admin: action.data };
    const res = yield call(apiFetcher.create, "admins", data);
    yield put({
      type: sagaCreateSuccess(ADMIN),
      data: res.data
    });
    if (res.data.success) {
      yield put(showSuccessMsg("Admin created successfully"));
    } else {
      yield put(
        showErrorMsg(
          "Sorry, errors were encountered whilst trying to save the data."
        )
      );
    }
  } catch (e) {}
}

export function* updateAdmin(action) {
  //restore old data to form when save fails -> probably in reducer
  try {
    const res = yield call(apiFetcher.update, "admins", action.data, action.id);
    yield put({
      type: sagaUpdateSuccess(ADMIN),
      data: res.data
    });
    if (res.data.success) {
      yield put(showSuccessMsg("Admin details updated successfully"));
    } else {
      yield put(
        showErrorMsg(
          "Sorry, errors were encountered whilst trying to save the data."
        )
      );
    }
  } catch (e) {}
}

export function* changeAdminPassword(action) {
  try {
    const data = { admin: action.data };
    const res = yield call(
      apiFetcher.makeRequest,
      "POST",
      `/api/admins/${action.data.id}/password`,
      data
    );
    yield put({
      type: "SAGA_CHANGE_ADMIN_PASSWORD_SUCCESS",
      data: res.data
    });
    if (res.data.success) {
      yield put(showSuccessMsg("Admin password updated successfully"));
    } else {
      yield put(
        showErrorMsg(
          "Sorry, errors were encountered whilst trying to update admin password."
        )
      );
    }
  } catch (e) {}
}



// WEBPACK FOOTER //
// ./src/sagas/admins.js